var map = {
	"./adjust.svg": 750,
	"./article.svg": 2333,
	"./multiple_elements.svg": 3279,
	"./note.svg": 6667,
	"./pen.svg": 1169,
	"./pin.svg": 8682,
	"./table.svg": 6708,
	"images/svg/make_learning_easier/adjust.svg": 750,
	"images/svg/make_learning_easier/article.svg": 2333,
	"images/svg/make_learning_easier/multiple_elements.svg": 3279,
	"images/svg/make_learning_easier/note.svg": 6667,
	"images/svg/make_learning_easier/pen.svg": 1169,
	"images/svg/make_learning_easier/pin.svg": 8682,
	"images/svg/make_learning_easier/table.svg": 6708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3994;